export default __webpack_public_path__ + "static/AeonikLight-d50086ac20cf7daa95cd962271824179.eot";